// Ported from packages/workflow-engine-upstream/ui/src/answer-text.ts at commit bebc382; only imports changed.
// The answer column's text: the summary under the headline, and plain names for the unknowns.

/** A list of findings or evidence rows longer than this starts closed, so the summary stays on screen. */
export const OPEN_LIST_MAX = 10;

/** The engine's prose without the headline it opens with, or '' when nothing else is left. */
export function summaryText(headline: string, prose: string): string {
  const text = prose.trim();
  return (text.startsWith(headline) ? text.slice(headline.length) : text).trim();
}

const UNKNOWN_LABELS: Record<string, string> = {
  missing: 'Missing',
  empty: 'No readings',
  unavailable: 'Not available',
  out_of_coverage: 'Outside the data',
  unmet_requirement: 'Not done',
};

export const unknownLabel = (kind: string) => UNKNOWN_LABELS[kind] ?? kind;
